import { render } from "./ManageRateView.vue?vue&type=template&id=b36caf5a"
import script from "./ManageRateView.vue?vue&type=script&lang=js"
export * from "./ManageRateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__